export const BALANCE_UPDATE_INTERVAL = 90_000

export const WAGMI_CONNECTOR_ID = {
  walletConnect: "walletConnect",
  okx: "okx",
}
